import * as Yup from "yup";
import {
  passwordMaxLength,
  passwordMinLength,
} from "../config/profileFieldLengths";

type PasswordRuleFunction = (t: Function) => Yup.StringSchema<string>;

const minLength: PasswordRuleFunction = (t) =>
  Yup.string()
    .min(
      passwordMinLength,
      t("error.validation.newPassword.policy.lengthAtLeast", {
        n: passwordMinLength,
      }),
    )
    .label(
      t("error.validation.newPassword.policy.lengthAtLeast", {
        n: passwordMinLength,
      }),
    );

const maxLength: PasswordRuleFunction = (t) =>
  Yup.string()
    .max(
      passwordMaxLength,
      t("error.validation.newPassword.policy.lengthAtMost", {
        n: passwordMaxLength,
      }),
    )
    .label(
      t("error.validation.newPassword.policy.lengthAtMost", {
        n: passwordMaxLength,
      }),
    );

const hasUpperCase: PasswordRuleFunction = (t) =>
  Yup.string()
    .matches(/(?=.*[A-Z])/, t("error.validation.newPassword.policy.uppercase"))
    .label(t("error.validation.newPassword.policy.uppercase"));

const hasLowerCase: PasswordRuleFunction = (t) =>
  Yup.string()
    .matches(/(?=.*[a-z])/, t("error.validation.newPassword.policy.lowercase"))
    .label(t("error.validation.newPassword.policy.lowercase"));

const hasNumbers: PasswordRuleFunction = (t) =>
  Yup.string()
    .matches(/(?=.*[0-9])/, t("error.validation.newPassword.policy.numbers"))
    .label(t("error.validation.newPassword.policy.numbers"));

const hasSpecialCharacters: PasswordRuleFunction = (t) =>
  Yup.string()
    .matches(
      /(?=.*[!@#$%^&*])/,
      t("error.validation.newPassword.policy.specialCharacters"),
    )
    .label(t("error.validation.newPassword.policy.specialCharacters"));

export {
  minLength,
  maxLength,
  hasUpperCase,
  hasLowerCase,
  hasNumbers,
  hasSpecialCharacters,
};
